import { v4 } from 'uuid'
import { cloneDeep } from 'lodash'

import { getConvertedData } from '../models/interface.helper'
import { mergeTicketsWithTabData } from '../helpers/tickets'
import useToasterHelper from '../helpers/ToasterHelper'

import { useAppDispatch, useAppSelector } from '../store/hooks'
import {
  selectRegistration,
  selectRegistrationTicketsR,
  selectTicketTabData,
  setRegistrationAc,
  setRegistrationsTicketsAc,
  setTicketTabData,
} from '../store/registration/registrationSlice'

import FirestoreService from '../services/firestoreService'

import { RegistrationTicketModel } from '../models/registration-tickets/registrationTicket.model'

import {
  ITicketTab,
  TEventRegisteredUsers,
} from '../models/event-registered-users/event-registered-users.interface'
import { IRegistrationTicketInterface } from '../models/registration-tickets/registrationTicket.interface'
import { ISelectedEvent } from '../store/events/eventsSlice'

import { MESSAGES_CONST } from '../const/messages-const'
import { CONST } from '../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.V01.COLLECTIONS

const useRegistrationTickets = () => {
  const dispatch = useAppDispatch()
  const toasterFunctions = useToasterHelper()

  const registration = useAppSelector(selectRegistration)
  const ticketTabData = useAppSelector(selectTicketTabData)
  const registrationTickets = useAppSelector(selectRegistrationTicketsR)

  const saveCartTickets = async (
    registrationUpdated: TEventRegisteredUsers,
    registrationTicketsUpdated: IRegistrationTicketInterface[]
  ) => {
    await FirestoreService.updateItem(
      COLLECTIONS.EVENT_REGISTERED_USERS.NAME,
      registration?.id,
      registrationUpdated
    )

    const ticketTabDataUpdated = mergeTicketsWithTabData(ticketTabData, registrationTicketsUpdated)

    dispatch(setTicketTabData(ticketTabDataUpdated))
    dispatch(setRegistrationsTicketsAc(registrationTicketsUpdated))
    dispatch(setRegistrationAc(registrationUpdated))
  }

  const onChangeTicket = async ({
    currentRow,
    selectedCount,
    publishedEvent,
  }: {
    currentRow: ITicketTab
    selectedCount: number
    publishedEvent: ISelectedEvent
  }) => {
    if (!registration) return

    const currentTicket = cloneDeep(currentRow)
    let registrationTicketsUpdated = cloneDeep(registrationTickets)

    try {
      registrationTicketsUpdated = registrationTicketsUpdated.filter(
        (ticket) => ticket.ticketItemId !== currentTicket.ticketItemId
      )

      if (selectedCount > 0) {
        for (let i = 0; i < selectedCount; i++) {
          registrationTicketsUpdated.push(
            getConvertedData({
              ...new RegistrationTicketModel({
                id: `${v4()}-${Date.now()}`,

                userId: registration?.userId ?? null,
                userName: registration?.userName ?? null,
                refundId: null,
                refundDocId: null,
                amountRefunded: 0,
                amountScratched: 0,
                ticketItemId: currentTicket.ticketItemId,
                paymentStatus: null,
                paymentType: null,
                eventId: registration?.eventId || null,
                eventName: registration?.eventName || null,
                selectedUnitsCount: 1,
                registrationDocId: registration?.id || null,
                ticketTitle: currentTicket.ticketTitle,
                ticketPrice: currentTicket.ticketPrice || 0,
                includeSalesTax: publishedEvent?.EventPaymentSettings?.chargeSalesTax || false,

                recipientId: registration?.userId || null,
                recipientName: registration?.userName || null,
                recipientProfilePicture: registration?.userProfilePicture || null,

                ownerId: registration.userId || null,
                ownerName: registration.userName || null,
                ownerProfilePicture: registration.userProfilePicture || null,
              }).toObject(),
            })
          )
        }
      }

      const registrationUpdated = {
        ...registration,
        cartItems: {
          ...registration?.cartItems,
          tickets: registrationTicketsUpdated,
        },
      }

      await saveCartTickets(registrationUpdated, registrationTicketsUpdated)
    } catch (error) {
      console.error(error, 'error')
      toasterFunctions.error({
        message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
    }
  }

  const onUpdateTickets = async ({
    registrationTicketsToUpdate,
  }: {
    registrationTicketsToUpdate: IRegistrationTicketInterface[]
  }) => {
    if (!registration) return

    let registrationTicketsUpdated = cloneDeep(registrationTickets)

    try {
      registrationTicketsUpdated = registrationTicketsUpdated.map((fee) => {
        const current = registrationTicketsToUpdate.find((item) => item.id === fee.id)
        if (current) {
          return current
        } else {
          return fee
        }
      })

      const registrationUpdated = {
        ...registration,
        cartItems: {
          ...registration?.cartItems,
          tickets: registrationTicketsUpdated,
        },
      }
      await saveCartTickets(registrationUpdated, registrationTicketsUpdated)
    } catch (error) {
      console.error('error:', error)
      toasterFunctions.error({
        message: MESSAGES_CONST.SOMETHING_WENT_WRONG,
      })
    }
  }

  return { onChangeTicket, onUpdateTickets }
}
export default useRegistrationTickets
